import styled from 'styled-components';

import GroverLogo from 'ggApp/shared/icons/GroverLogo';

import { screens } from 'ggApp/utils/mixins/screens';
import LogoSmall from './images/logo.svg';
import InfoIcon from './images/info.svg';

export const Header = styled.div`
    padding: 0 30px;

    @media (${screens.phone}) and (${screens.desktopMax}) {
        padding: 15px;
        width: 100%;
    }
`;

export const Wrap = styled.div`
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (${screens.phone}) and (${screens.desktopMax}) {
        height: auto;
    }
`;

export const PartnerLogo = styled.img`
    display: block;
    width: 100%;
    max-width: 150px;
    max-height: 70px;

    @media (${screens.phone}) and (${screens.desktopMax}) {
        max-width: 45px;
        max-height: 45px;
    }
`;

export const DesktopLogo = styled(GroverLogo)`
    width: 150px;
    height: 70px;
`;

export const MobileLogo = styled.div`
        width: 45px;
        height: 45px;
        background-image: url(${LogoSmall});
        background-position: 0 50%;
        background-repeat: no-repeat;
        background-size: auto auto;
`;

export const NaviInfoIcon = styled.div`
    @media (${screens.phone}) and (${screens.desktopMax}) {
        width: 45px;
        height: 45px;
        background-image: url(${InfoIcon});
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: auto 60px;
        cursor: pointer;

        z-index: 100;
        position: relative;
    }
`;
